// extracted by mini-css-extract-plugin
module.exports = {"container":"PageError_container__2IQBg","card":"PageError_card__1ulfY","icon":"PageError_icon__wE86i"};